import * as React from "react"

const SvgRecPaid = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M19.786 9.9q.685 0 1.2.514.514.515.514 1.2v1.715q0 .1-.02.212a6 6 0 0 0-1.694-.842v-1.085H12.07L13.23 6.9 9.5 10.629v8.7h2.567a6 6 0 0 0 .531 1.714H5.214a1.65 1.65 0 0 1-1.21-.504 1.65 1.65 0 0 1-.504-1.21v-7.715q0-.707.504-1.21a1.65 1.65 0 0 1 1.21-.504h2.572l5.143-5.1q.32-.322.76-.375t.847.16q.406.216.6.6.193.386.085.794L14.257 9.9zm-12 9.429v-7.715H5.214v7.715z"
      clipRule="evenodd"
    />
    <path d="M17.57 22.27a.55.55 0 0 0 .389.159.5.5 0 0 0 .365-.16.56.56 0 0 0 .155-.403v-.122q.792-.147 1.3-.68.506-.532.507-1.24 0-.784-.427-1.255t-1.33-.776q-.867-.294-1.115-.502-.247-.208-.247-.44 0-.208.204-.355t.55-.147q.174 0 .354.055t.29.165q.285.22.526.288a.7.7 0 0 0 .44-.006.6.6 0 0 0 .365-.373.52.52 0 0 0-.068-.496 1.8 1.8 0 0 0-.588-.544 2.9 2.9 0 0 0-.761-.3v-.147a.57.57 0 0 0-.149-.403.5.5 0 0 0-.383-.16.544.544 0 0 0-.544.563v.147q-.818.184-1.201.703-.384.52-.384 1.07 0 .71.446 1.169t1.448.801q.667.209.946.434.279.226.279.508 0 .256-.242.459-.24.202-.674.202-.223 0-.489-.147a1.4 1.4 0 0 1-.464-.416.86.86 0 0 0-.415-.33.72.72 0 0 0-.488 0 .61.61 0 0 0-.39.342.58.58 0 0 0-.007.502q.224.451.65.789.428.336.984.483v.159q0 .245.167.404Z" />
  </svg>
)
export default SvgRecPaid
